export const decodeString = (str: $TSFixMe) => {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = str;
    return textarea.value;
};

export default function generateContentText(content: $TSFixMe) {
    if (content?.Quill) {
        return decodeString(
            content.Quill.ops
                .slice(0, -1)
                .filter((op: $TSFixMe) => !!op.insert)
                .map((op: $TSFixMe) => (typeof op.insert === 'string' ? op.insert : op.insert?.url?.text || op.insert?.link?.text || ''))
                .join('')
        );
    }
    return decodeString(content?.Text || '');
}
